import { Tile } from "ol/layer";
import XYZ from "ol/source/XYZ";
import TileGrid from "ol/tilegrid/TileGrid";
import { ServerLayer } from "../../../lib/layers";
import { Some } from "../../../lib/misc/option";
export class TileLayer extends ServerLayer {
    constructor(opts) {
        super(opts);
    }
    get layers() {
        return this.raw.map(l => [l]).unwrapOr([]);
    }
    validate(opts) {
        let result = true;
        result && (result = typeof opts.infoUrl === 'string');
        result && (result = Array.isArray(opts.exportUrl) && opts.exportUrl.every(u => typeof u === 'string'));
        result && (result = opts.isBaseLayer !== undefined && opts.visible !== undefined);
        result && (result = typeof opts.isBaseLayer === 'boolean' && typeof opts.visible === 'boolean');
        return result;
    }
    async parse_config(opts) {
        var _a, _b;
        this.is_base = opts.isBaseLayer;
        this.name = opts.name;
        const api = await this.get_service_api(opts.exportUrl);
        if (!api) {
            console.error(`Tile layer "${opts.name}" loading failed. See console logs.`);
            this.parsing_failed = true;
            return;
        }
        ;
        if (!api.is_cached) {
            console.error(`Tile layer "${opts.name}" doesn't not have an active tile cache. Loading skipped`);
            this.parsing_failed = true;
            return;
        }
        const urls = api.endpoints.map(e => {
            let url = `${e}/tile/{z}/{y}/{x}`;
            if (api && api.token) {
                url += `?token=${api.token}`;
            }
            return url;
        });
        const layer = new Tile({
            extent: api.extent,
            opacity: opts.opacity,
            visible: opts.visible,
            source: new XYZ({
                urls: urls,
                crossOrigin: 'anonymous',
                projection: api.projection,
                tileGrid: new TileGrid({
                    extent: api.extent,
                    origin: api.origin,
                    tileSize: api.tile_size,
                    resolutions: api.cached_resolutions
                })
            })
        });
        this.raw = new Some(layer);
        this.projection = api.projection;
        (_a = layer.getSource()) === null || _a === void 0 ? void 0 : _a.on("tileloadstart", () => {
            this.display_loading_indicator(true);
        });
        (_b = layer.getSource()) === null || _b === void 0 ? void 0 : _b.on("tileloadend", () => {
            this.display_loading_indicator(false);
        });
    }
}
